// 引入element中文语言
import eleZh from 'element-ui/lib/locale/lang/zh-CN'
import ivieweZh from 'view-design/dist/locale/zh-CN'
import index from '@/views/index/locales/zh'
import settlement from '@/views/settlement/locales/zh' // 结算报表
// import dataReport from "views/dataReport/locales/zh"; // 交易分析模块
import tradeEchart from '@/views/transactionAnalysis/locales/zh' // 交易分析模块

import paymentRecord from '@/views/paymentRecord/locales/zh' // 自动提现模块
import fundManagement from '@/views/fundManagement/locales/zh' // 提现模块
import components from '@/components/locales/zh' // compontnts文件夹中的公共组件
import webList from '@/views/websiteCenter/locales/zh' // 网站管理
import login from '@/views/login/locales/zh' // 登录注册
import home from '@/views/exhibition/locales/zh' // 首页
import account from '@/views/accountCenter/locales/zh' // 账号中心
import chargeBack from '@/views/riskManagement/chargeback/locales/zh' // 拒单
import certification from '@/views/certification/locales/zh' // 实名认证
import cashAccount from '@/views/cashAccount/locales/zh' // 提现账户
import logistics from '@/views/logisticsManage/locales/zh' // 物流管理
import riskTranscation from '@/views/riskManagement/riskTransactionManagement/locales/zh' // 风险订单
import system from '@/views/system/locales/zh' // 权限管理=
import withdrawModule from '@/views/withdrawModule/locales/zh' // 提现模块
import homePage from '@/views/homePage/locales/zh' // 首页
import messageReceiverSetting from '@/views/messageReceiverSetting/locales/zh' // 首页
import blackList from '@/views/riskManagement/blackList/locales/zh' // 黑名单
import whiteList from '@/views/riskManagement/whiteList/locales/zh' // 白名单
import selectWebsite from '@/views/ppAuthorization/locales/zh'
import tradeType from '@/views/trade-type/locales/zh'
import paymentLink from '@/views/paymentLink/locales/zh'
import checkoutCustomSettings from '@/views/checkoutCustomSettings/locales/zh'
import messageCenter from '@/views/messageCenter/locales/zh' // 消息中心
import disputeManage from '@/views/riskManagement/disputeManage/locales/zh' // 争议订单管理
import offlineKyc from '@/views/offlineKyc/locales/zh' // 线下KYC
import storeManage from '@/views/storeManage/locales/zh'
import landing from '@/views/landing/locales/zh' // 官网

const zh = {
	...eleZh,
	...ivieweZh,
	index,
	settlement,
	// dataReport,
	tradeEchart,
	paymentRecord,
	certification,
	fundManagement,
	components,
	chargeBack,
	webList,
	account,
	login,
	home,
	logistics,
	withdrawModule,
	cashAccount,
	riskTranscation,
	homePage,
	system,
	messageReceiverSetting,
	blackList,
	whiteList,
	selectWebsite,
	tradeType,
	paymentLink,
	checkoutCustomSettings,
	messageCenter,
	disputeManage,
	offlineKyc,
	storeManage,
	landing
}
export default zh
